import { render, staticRenderFns } from "./EditSection.vue?vue&type=template&id=0f86311c&scoped=true&"
import script from "./EditSection.vue?vue&type=script&lang=js&"
export * from "./EditSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f86311c",
  null
  
)

export default component.exports